import React, { useContext } from "react";
import { Loading, toast } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";
import {
  ContextEditLabel,
  useContextEditLabel,
} from "@dimensions/group/EditLabels/ContextEditLabels";
import { Label } from "@models/ISchema";
import { emitEvent } from "@common/hooks/useListenEvent";
import { ContextApp } from "@config/Context/contextApp";
import TagsDrawer from "@dimensions/common/tags-drawer";
import useContextUrl from "@common/hooks/useContextUrl";
import useEditPackageLabels from "@dimensions/package/hooks/useEditPackageLabels";

interface PackageTagsDrawerProps {
  isOpen?: boolean;
  labels?: Label[];
  onClose?: () => void;
}

const PackageTagsDrawer = ({ isOpen = true, labels, onClose }: PackageTagsDrawerProps) => {
  const { t } = useTranslation();
  const { user } = useContext(ContextApp);
  const contextEdit = useContextEditLabel();
  const { id, scenario, origin } = useContextUrl();
  const [{ isSavingLabels }, updatePackageLabels] = useEditPackageLabels(id, scenario, origin);

  const handleUpdateLabels = () => {
    updatePackageLabels(contextEdit.labels, () => {
      onClose?.();
      emitEvent("on:refresh", { target: "package-calendar" });
      toast.success(t("edit-tag-manually.success-message"), { autoClose: 3000 });
    });
  };

  return (
    <ContextEditLabel.Provider value={contextEdit}>
      {isSavingLabels && <Loading />}
      <TagsDrawer
        isOpen={isOpen}
        labels={labels}
        canEdit={user?.permissions?.update}
        onSaveLabels={handleUpdateLabels}
        onClose={onClose}
      />
    </ContextEditLabel.Provider>
  );
};

export default PackageTagsDrawer;
